<template>
    <div class="msg">
        <v-text-field :label="getI18n( 'name' )" v-model="name" outline ></v-text-field>
        <v-text-field :label="getI18n( 'username' )" v-model="username" outline ></v-text-field>
        <v-text-field :label="getI18n( 'password' )" v-model="password" type="password" outline ></v-text-field>
        <v-text-field :label="getI18n( 'email' )" v-model="email" outline ></v-text-field>
        <v-select id="lang" v-model="lang" :items="langs" :label="getI18n('params.language')" ></v-select>
    </div>
</template>

<script>
    import store from '@/store'
    import i18n from '@/i18n'
    import {Api} from '@/core/api.js';
    const api = new Api();

    export default {
        props: { params: Object },
        components: { },
        data() {
            return {
                team_id: this.params.team.value,
                event_id: this.params.event.value,
                name: this.params.name.value,
                username: this.params.username.value,
                password: this.params.password.value,
                email: this.params.email.value,
                lang: this.params.lang.value,
            }
        },
        computed: {
            events: function(){
                var events = store.getters[ 'events/getActives' ]();
                var aEvents = [];
                for( var i in events ){
                    var e = events[ i ];
                    aEvents.push( { text: e.name, value: e.id } );
                }

                return aEvents;
            },
            users: function() {
                var users = store.getters[ 'user/getList' ]();
                var aUsers = [];
                for( var i in users ){
                    var u = users[ i ];
                    aUsers.push( { text: u.name, value: u.id } );
                }

                return aUsers;
            },
            langs: function() {
                var langs = store.state.languages;
                var aLangs = [];
                for( var k in langs ){
                    aLangs.push( {  text: langs[k].fullname, value: langs[k].id })
                }

                return aLangs
            }
        },
        methods: {
            getI18n( label ){
                return i18n.t( label );
            },

            formatParam( param ){
                switch( param.type ){
                    case 'string': return param.value;
                    case 'role': return param.value.name;
                    case 'email': return param.value;
                    case 'phone': return "<v-icon size='18px'>phone</v-icon>" + param.value;
                }
            }
        },
        watch: {
            name: {
                handler( v ){
                    this.params.name.value = v
                },
                deep: true
            },
            username: {
                handler( v ){
                    this.params.username.value = v
                },
                deep: true
            },
            password: {
                handler( v ){
                    this.params.password.value = v
                },
                deep: true
            },
            email: {
                handler( v ){
                    this.params.email.value = v
                },
                deep: true
            },
            lang: {
                handler( v ){
                    this.params.lang.value = v
                },
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .avatar {
        width: 100%;
        height: 150px;
        text-align: center;

        img {
            height: 100%;
            width: auto;
        }
    }

    .item {
        text-align: center;
        margin: 10px auto;
        width: fit-content;

        &.strong .value {
            font-weight: bold;
            font-size: 22px;
        }

        &.role {
            border-radius: 15px;
            padding: 5px 15px;
            font-weight: lighter;
            margin: 0 auto;
            
            &.r5 {
                background-color: $bg-role-5;
                color: $co-role-5;
            }

            & .value {
                font-size: 18px;
                text-transform: uppercase;
            }
        }
        
        &.club {
            position: relative;
        }
    }
</style>